import { AccessEventsPage } from 'graphql/generated/graphqlTypes';

export function generateMockAccessEventsPage({
  items = [],
  nextToken = null
}: Partial<Omit<AccessEventsPage, '__typename'>>): AccessEventsPage {
  return {
    __typename: 'AccessEventsPage',
    items,
    nextToken
  };
}
